export const IS_COMPLETED_STATUS = [
  { Name: "Ej klar", Value: false },
  { Name: "Klar", Value: true },
];
